import { render } from "./AIChatBubble.vue?vue&type=template&id=5d20d76a&scoped=true"
import script from "./AIChatBubble.vue?vue&type=script&lang=js"
export * from "./AIChatBubble.vue?vue&type=script&lang=js"

import "./AIChatBubble.vue?vue&type=style&index=0&id=5d20d76a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d20d76a"]])

export default __exports__